import { render, staticRenderFns } from "./display-chiffres-cles.vue?vue&type=template&id=8a1430d0&scoped=true"
import script from "./display-chiffres-cles.vue?vue&type=script&lang=js"
export * from "./display-chiffres-cles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1430d0",
  null
  
)

export default component.exports